<template>
  <app-layout>
    <customer-accounting-control-table
      :own-consultant="consultant_id"
    ></customer-accounting-control-table>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import CustomerAccountingControlTable from '../components/CustomerAccountingControlTable';
export default {
  name: 'AccountingControl',
  components: { CustomerAccountingControlTable, AppLayout },
  beforeMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.hasOwnProperty('consultant_profile') && user.consultant_profile !== null) {
      this.consultant_id = user.consultant_profile['id'];
    }
  },
  data() {
    return {
      consultant_id: null,
    };
  },
  computed: {
    consultant() {
      return this.consultant_id;
    },
  },
};
</script>

<style scoped></style>
